import { ServiceOfflineService } from '~/sqlite/services/service';

export class ServiceLocalDataSource extends ServiceOfflineService {}

export const serviceLocal = new ServiceLocalDataSource();
